(function ($, app) {
	var cid = !!location.href.match(/eventsales.aspx/i) && 'e' || app.globalQueryParams['cid'] || 10;

	app.saleCategories = function(selectedClassName) {
		$(function() {
			$('a[data-cid="' + cid + '"]').addClass(selectedClassName);
		});
	};
})(jQuery, app);